'use strict';
namespace Core {

    export class PostBookingLookup {

        constructor(private $location: ng.ILocationService, private authService) {
        }

        redirect(): void {
            if (TRPCONFIG.Domain.DashboardBookingEnabled) {
                let bookingId = this.authService.getSignedInBookingId();
                if(bookingId) {
                    this.$location.path('dashboard/bookings/reference/' + bookingId);
                }
                return;
            }
            document.location.href = '/manage-your-booking/options.aspx';
        }

    }

    angular
        .module('core')
        .service('postBookingLookup', PostBookingLookup);

}
